module.exports = __webpack_public_path__ + "static/hero-f84fe1830296dc2d7b88b32e63a30f90.png";